<script>

export default {
	name: 'Pagination',
	
	components: {
	
	},
	
	data() {
		return {
			countPages:0,
			page:0
		}
	},
	
	emits: ["onSelectPage"],

	props: {'selectedPage': Number, 'selectedRecords': Number, 'totalCount': Number },
	
	mounted:function(){
		this.setCountPages();
	},
	
	methods: {

		setCountPages:function(){
			if(this.selectedRecords >= this.totalCount){
				this.countPages = 1;
				this.page = 1;
			}else{
				this.countPages = Math.ceil(this.totalCount / this.selectedRecords);
				if(this.page > this.countPages){
					this.page = 1;
				}
			}
		},

		selPage:function(x){
			var y = this.selectedPage;
			if(x=='prev' || x=='next'){
				if(x=='prev'&&y!=1){y=y-1}
				if(x=='next'&&y!=this.countPages){y=y+1}
			}else{
				if(y != x){
					y = Number(x);
				}
			}
			this.$emit('onSelectPage', y)
		}
	},	
	
	watch: {
		selectedPage() {
			this.setCountPages();
		},
		selectedRecords() {
			this.setCountPages();
		},
		totalCount() {
			this.setCountPages();
		},
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div class="form-group form-group-filter">
		<nav aria-label="...">
			<ul class="pagination pagination-sm">
			
			<li class="page-item"><button  v-on:click="selPage('prev')" :disabled="selectedPage==1" class="btn page-link" v-bind:class="{'in-active':selectedPage==1}" href="#" >{{$t('msgCore.PrevPage')}}</button></li>
			
			<span v-for="i in countPages" :key="i">
	
				<li v-if="i==1 && i!=selectedPage" class="page-item"><button class="btn page-link" href="#" v-on:click="selPage(i)" >{{i}}</button></li>

			
				<li v-else-if="i>=selectedPage-1 && i!=selectedPage && i<selectedPage" class="page-item"><button class="btn page-link" href="#" v-on:click="selPage(i)" >{{i}}</button></li>
		
	
				<li v-else-if="i==selectedPage" class="page-item active">
					<button id="<?php echo $i; ?>"  class="btn page-link" href="#" v-on:click="selPage(i)" >{{i}}</button>
				</li>
		

				<li v-else-if="i<=selectedPage+1 && i!=selectedPage && i>selectedPage" class="page-item"><button class="btn page-link" href="#" v-on:click="selPage(i)">{{i}}</button></li>
		
				<li v-else-if="i==countPages && i!=selectedPage" class="page-item"><button class="btn page-link" href="#" v-on:click="selPage(i)">{{i}}</button></li>
		
			</span>
			
			<li class="page-item"><button v-on:click="selPage('next')" :disabled="selectedPage==countPages" class=" btn page-link" v-bind:class="{'in-active':selectedPage==countPages}" href="#" >{{$t('msgCore.NextPage')}}</button></li>
			
			
			</ul>
		</nav>
	</div>
</template>


